import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CHARACTERS } from "@/data/characters";

const CharacterCard = ({ c, i }) => (
  <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }}>
    <Link
      to={`/characters/${c.slug}`}
      data-testid={`character-card-${c.slug}`}
      className="group block overflow-hidden rounded-[2rem] border-4 bg-white shadow-[0_16px_40px_rgba(11,79,163,0.12)] transition-transform duration-300 hover:-translate-y-2 hover:rotate-[-1deg]"
      style={{ borderColor: c.theme.main }}
    >
      <div className="relative aspect-[5/3] overflow-hidden" style={{ background: c.theme.soft }}>
        <img src={c.portrait} alt={c.name} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
      </div>
      <div className="flex items-center justify-between gap-3 p-6">
        <div>
          <p className="font-display text-3xl font-bold" style={{ color: c.theme.deep }}>{c.name}</p>
          <p className="text-sm font-semibold text-slate-500">{c.role}</p>
        </div>
        <span className="shrink-0 whitespace-nowrap rounded-full px-4 py-2 font-display text-sm font-semibold text-white transition-transform group-hover:scale-110" style={{ background: c.theme.deep }}>
          Say hi!
        </span>
      </div>
    </Link>
  </motion.div>
);

export const Gallery = () => (
  <section id="friends" data-testid="character-gallery" className="mx-auto max-w-7xl scroll-mt-24 px-4 py-16 sm:px-8 sm:py-24">
    <p className="font-display text-lg font-semibold text-[#1e9bf0]">The gang's all here</p>
    <h2 className="mt-1 font-display text-4xl font-bold text-[#0b4fa3] sm:text-5xl">Meet Handy & Friends</h2>
    <div className="mt-12 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
      {CHARACTERS.map((c, i) => <CharacterCard key={c.slug} c={c} i={i} />)}
    </div>
  </section>
);
